import { __assign, __rest, __spreadArray } from "tslib";
import { handleDeleteItemsAction as handleDeleteItemsActionBase, handleFetchSuccessAction, } from '../base/actionHandlers';
/**
 * Inserts a set of items into the stream at a given offset
 *
 * IMPORTANT: We do best guess with nextOffset tracking, as its
 * backend dependent please think about using this before using it!
 * Some backends or UX cases might not handle our simple method of
 * moving the next offset pointer forward.
 *
 * This is also not available for cursor based things because there
 * is no way to cleanly increment the offset.
 *
 * @param streamState
 * @param action
 */
export var handleInsertItemsAction = function (streamState, action) {
    var nextOffset = streamState.nextOffset;
    var shouldUpdateNextOffset = !action.doNotUpdateNextOffset;
    if (shouldUpdateNextOffset && nextOffset !== undefined) {
        nextOffset += action.items.length;
    }
    var total = streamState.total !== undefined
        ? streamState.total + action.items.length
        : undefined;
    // Prepend - optimisation concat faster than slice and spread
    if (action.offset === 0) {
        return __assign(__assign({}, streamState), { nextOffset: nextOffset, items: action.items.concat(streamState.items || []), total: total });
    }
    // Append - optimisation concat faster than slice and spread
    if (action.offset === streamState.items.length) {
        return __assign(__assign({}, streamState), { nextOffset: nextOffset, items: (streamState.items || []).concat(action.items), total: total });
    }
    // Inject
    var current = streamState.items || [];
    var newItems = __spreadArray(__spreadArray(__spreadArray([], current.slice(0, action.offset), true), action.items, true), current.slice(action.offset), true);
    return __assign(__assign({}, streamState), { nextOffset: nextOffset, items: newItems, total: total });
};
/**
 * Merges in fetch results. This operates under the assumption that
 * there are no duplicate items in the stream; and if there are dupes
 * in the fetched stream they must be the result of accidental double-fetching
 * and can be safely discarded.
 *
 * IMPORTANT: do not use on streams that can possibly hold duplicates!
 * If unsure, do not use!
 *
 * @param streamState
 * @param action
 */
export var dedupeFetchResults = function (streamState, action) {
    var _a = streamState.items, items = _a === void 0 ? [] : _a;
    var actionItems = action.items, _b = action.dedupeFunction, dedupeFunction = _b === void 0 ? function (item, existingItems) { return !existingItems.includes(item); } : _b, nextOffset = action.nextOffset, baseAction = __rest(action, ["items", "dedupeFunction", "nextOffset"]);
    if (streamState.nextOffset &&
        nextOffset &&
        nextOffset <= streamState.nextOffset) {
        // we already got all we had in this fetch
        return streamState;
    }
    // we want to dedupe already existing items from the stream
    var filteredItems = actionItems === null || actionItems === void 0 ? void 0 : actionItems.filter(function (item) {
        return dedupeFunction(item, items);
    });
    return __assign(__assign({}, handleFetchSuccessAction(streamState, __assign(__assign({}, baseAction), { items: filteredItems }))), { nextOffset: nextOffset });
};
export var handleDeleteItemsAction = function (streamState, action) {
    var items = streamState.items, _a = streamState.nextOffset, nextOffset = _a === void 0 ? null : _a;
    var prevItemsCount = items.length;
    var newStreamState = handleDeleteItemsActionBase(streamState, action);
    var removedItemsCount = prevItemsCount - newStreamState.items.length;
    var shouldUpdateNextOffset = !action.doNotUpdateNextOffset;
    if (shouldUpdateNextOffset && nextOffset !== null) {
        return __assign(__assign({}, newStreamState), { nextOffset: nextOffset - removedItemsCount });
    }
    return newStreamState;
};
//# sourceMappingURL=actionHandlers.js.map